import apiProxy from "../../services/apiProxy";
import {
  SLUG_API
} from "../../config/api";

const state = {
  slug: "",
  currency: "",
  siteName: ""
};

const getters = {
  getSlug: (state) => state.slug,
  getCurrency: (state) => state.currency,
  getSiteName: (state) => state.siteName,
};

const actions = {
  setSlug({
    commit
  }) {
    return apiProxy
      .callPreAuth(SLUG_API, {})
      .then(
        (response) => {
          let dataSent = response;
          if (dataSent.code == "1") {
            commit("setNewSlug", dataSent.slug);
            if (dataSent.slug == "HER" || dataSent.slug == "NOC" || dataSent.slug == "FM1" || dataSent.slug == "FMM" || dataSent.slug == "BRE" || dataSent.slug == "SZG" || dataSent.slug == "PB1") {
              dataSent.currency = "€";
            }
            commit("setNewCurrency", dataSent.currency);
            commit("setNewSiteName", dataSent.sitename);
            return dataSent.slug;
          } else {
            console.log(dataSent.slug);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  },
};

const mutations = {
  setNewSlug: (state, slug) => (state.slug = slug),
  setNewCurrency: (state, currency) => (state.currency = currency),
  setNewSiteName: (state, siteName) => (state.siteName = siteName),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
